'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/istanbul/~/supports-color/browser.js
// module id = 3124
// module chunks = 0